import { render, staticRenderFns } from "./Instant.vue?vue&type=template&id=1bfd25e8&scoped=true&"
import script from "./Instant.vue?vue&type=script&lang=js&"
export * from "./Instant.vue?vue&type=script&lang=js&"
import style0 from "./Instant.vue?vue&type=style&index=0&id=1bfd25e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd25e8",
  null
  
)

component.options.__file = "Instant.vue"
export default component.exports